export default __webpack_public_path__ + "static/kindergarten-readiness2-b1fce5d47102d9df7cc5d94a7e89e7f6.jpg";